import { Center, Skeleton } from '@chakra-ui/react';
import CustomDataTableEditBtn from '@Modules/core/components/table/CustomDataTableEditBtn';
import { createColumnHelper } from '@tanstack/react-table';

export type TRequiredDocumentsDataTableData = {
  primaryKey: string | number,
  documentType: string,
  status: string,
};

type Props = {
  isLoading: boolean | undefined,
  handleEdit: (row: any) => void,
};

const columnHelper = createColumnHelper<TRequiredDocumentsDataTableData>();

export function getRequiredDocumentsDataTableColumns({ isLoading, handleEdit }: Props) {
  return [
    columnHelper.accessor('documentType', {
      id: 'documentType',
      header: 'Type Document',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('status', {
      id: 'status',
      header: 'Statut',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.display({
      id: 'action',
      header: '',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>
              <CustomDataTableEditBtn onClick={() => handleEdit(props.row)} />
            </Center>
          </Skeleton>
        );
      },
    }),
  ];
}